var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.625 3.034-.683.684-.792-.8a.84.84 0 0 0-1.183 0l-.8.8-.8-.8a.84.84 0 0 0-1.184 0l-.791.8-.8-.8a.83.83 0 0 0-1.175 0l-.8.8-.8-.8a.84.84 0 0 0-1.184 0l-.8.8-.8-.8a.84.84 0 0 0-1.183 0l-.792.8-.683-.684a.417.417 0 0 0-.708.3V15.66c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V3.334a.417.417 0 0 0-.708-.3zM9.167 15.66H3.333v-5h5.834zm7.5 0h-5.834v-1.666h5.834zm0-3.333h-5.834v-1.667h5.834zm0-3.333H3.333v-2.5h13.334z",
    fill: "#29c1db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.e35f23cb6ff76085f5597f93dbc65ef1.svg";
export { ForwardRef as ReactComponent };